import axios from 'axios';
import {
    GENERIC_AUTHENTICATION_PARAMETERS, getRedirectParameters, getRedirectUriParam,
    hasParameter, LOGOUT_PARAMETER, REDIRECT_QUERY_PARAMETER_KEY,
    REFRESH_AUTHENTICATION_PARAMETERS
} from "./queryparam";
import {getRedirectUri, saveRefreshToken} from "./storage";

const API_BASE_URL = `${window.location.origin.includes("localhost") ? 'http' : 'https'}://${window.location.host}`;

export const API_AUTH = {
    COMMON_AUTH_V1: API_BASE_URL.concat('/boschung/api/common/auth/v1'),
    TOKEN_ENDPOINT: '/oauth/token',
    AUTHORIZATION_CODE_ENDPOINT: '/oauth/code'
};

const apiService = apiUrl => axios.create({ baseURL: apiUrl });

export const refreshAuthentication = (refreshToken) => {
    const body = new FormData();
    body.set('refresh_token', refreshToken);

    return (
        apiService(API_AUTH.COMMON_AUTH_V1)
            .post(`${API_AUTH.TOKEN_ENDPOINT}${REFRESH_AUTHENTICATION_PARAMETERS}`, body)
            .then(doRedirectFromResponse)
    );
}

export const authenticate = (username, password) => {
    const body = new FormData();
    body.set('username', username);
    body.set('password', password);

    return (
        apiService(API_AUTH.COMMON_AUTH_V1)
            .post(`${API_AUTH.TOKEN_ENDPOINT}${GENERIC_AUTHENTICATION_PARAMETERS}`, body)
            .then(doRedirectFromResponse)
            .catch(error => {
                console.error(error);
                return Promise.reject(error);
            })
    );
}
export const hasLoggedOut = () => hasParameter(LOGOUT_PARAMETER);

export const doRedirectFromResponse = (response) => {
    const { access_token, refresh_token } = response.data;
    doRedirect(access_token, refresh_token);
}

export const doRedirect = (accessToken, refreshToken) => {
    saveRefreshToken(refreshToken);
    let redirectUri;
    if (hasParameter(REDIRECT_QUERY_PARAMETER_KEY) || getRedirectUri() !== null) {
        redirectUri = getRedirectUriParam() || getRedirectUri();
    } else {
        redirectUri = getDefaultLandingPage();
    }
    if (redirectUri !== null) window.location.href = `${redirectUri}${getRedirectParameters(accessToken, refreshToken)}`;
}

const getEnv = () => {
    let env = "prod";
    try {
        env = window.location.href.match('://(.*)-services.*')[1];
    } catch (e) {}

    return env;
}

const getDefaultLandingPage = () => {
    const baseDefaultUrl = 'https://%ENV%.badmin.digital/#/userprofile/userprofile'
    let env = getEnv();
    if (env === null) return null;

    return env === 'prod' ?
        baseDefaultUrl.replace('%ENV%.', '') :
        baseDefaultUrl.replace('%ENV%', env);
}

export const getAzureClientId = () => {
    return window.azureClientId;
}

export const getAzureScopes = () => {
    return window.azureScopes;
}

export const getAzureTenantId = () => {
    return window.azureTenantId;
}

export const isAzureEnabled = () => {
    return window.azureEnabled;
}
